import { render, staticRenderFns } from "./ClassHistoryChart.vue?vue&type=template&id=0f444898&"
import script from "./ClassHistoryChart.vue?vue&type=script&lang=js&"
export * from "./ClassHistoryChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports